// extracted by mini-css-extract-plugin
export var compactFilters = "_es-4";
export var detailImage = "_es-1";
export var dropdownContainer = "_es-2";
export var imageContainer = "_es-0";
export var selectedCard = "_es-3";